<template>
  <div class="Resume">
    <div class="header">
      <div class="title">
        <span
          @click="back"
          style="cursor: pointer; color: #4587ff; margin-right: 20px"
          ><i class="el-icon-arrow-left"></i>返回</span
        >
        个人专属
      </div>
    </div>
    <div class="card_box">
      <div class="head_img">
        <img :src="userData.headImg" mode="aspectFill" />
      </div>
      <div class="user_info">
        <div
          class="top_box"
          :style="{
            justifyContent: 'space-between;',
          }"
        >
          <div class="name_box">
            <span class="name">{{ userData.name }}</span>
            <span class="label" v-if="userData.remark">{{
              userData.remark
            }}</span>
            <div class="start">
              <img :src="wqUrl + 'aiExistingWritings_score.png'" mode="" />
              4.5
            </div>
          </div>
        </div>
        <div class="msgInfo">
          <span
            ><span style="color: #f52c26">￥{{ userData.lowestPrice }}</span
            >起 | {{ userData.worksNum }} 作品 |
            {{ userData.fansNum }} 粉丝</span
          >
        </div>
      </div>
    </div>
    <div
      class="banner"
      :style="{
        height: 'calc(100vh - 396rpx)',
      }"
    >
      <div class="tabs_box">
        <div
          :class="['min_spec', specXZ === i ? 'xuanz' : '']"
          @click="tabClick(i)"
          v-for="(el, i) in tabList"
          :key="el.title"
        >
          <img
            :src="specXZ === i ? wqUrl + el.img_current : wqUrl + el.img"
            mode=""
          />
          {{ el.title }}
        </div>
      </div>
      <div v-if="specXZ === 0">
        <div class="bigBox">
          <div class="info">
            <div class="title">基本信息</div>
            <span>{{ userData.introduction || '' }}</span>
          </div>
          <div class="info">
            <div class="title">学习/工作经历</div>
            <span>{{ userData.experience || '' }}</span>
          </div>
          <div class="info">
            <div class="title">担任职务</div>
            <span>{{ userData.appointment || '' }}</span>
          </div>
        </div>
      </div>
      <div v-if="specXZ === 1">
        <professionalServicesCom :userData="userData" ref="professional" />
      </div>
    </div>
  </div>
</template>

<script>
import { architectInfo } from 'api/professionServer'
import qs from 'qs'
import professionalServicesCom from './professionalServicesCom.vue'
export default {
  props: ['infoData'],
  components: {
    professionalServicesCom,
  },
  watch: {
    infoData(val) {
      this.getUser()
    },
  },
  data() {
    return {
      imgUrl: 'https://fafs.antiplagiarize.com/', // 图片url
      wqUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/', // 图片url

      navHeight: 0, // 导航栏高度
      statusHei: 0, // 状态栏高度
      userData: {}, // 用户数据
      tabList: [
        {
          title: '个人简介',
          img: 'Resume_resume.png',
          img_current: 'Resume_resume_current.png',
        },

        {
          title: '专业服务',
          img: 'Resume_fuwu.png',
          img_current: 'Resume_fuwu_current.png',
        },
      ],
      specXZ: 0,
      isShare: false,
    }
  },

  async created() {
    this.getUser()
  },

  methods: {
    async getUser() {
      let res = await architectInfo(
        qs.stringify({
          userId: this.infoData,
        })
      )
      if (res.code !== 200) return
      this.userData = res.data
    },
    back() {
      this.$emit('back')
    },

    tabClick(i) {
      this.specXZ = i
    },
  },
}
</script>

<style lang="scss" scoped>
.Resume {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  .card_box {
    // width: 345px;
    height: 94px;
    position: relative;
    padding: 20px 15px 20px 35px;
    box-sizing: border-box;
    margin-top: 10px;
    display: flex;
    background: url('https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/Resume_card_bg.png')
      no-repeat;
    background-size: 100% 100%;
    .share {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
    }
    .share_but {
      position: absolute;
      top: 10px;
      right: -300px;
      z-index: 8;
      background: #326afb;
      width: 30px;
      height: 30px;
    }
    .head_img {
      width: 54px;
      height: 54px;
      background: #ccc;
      border-radius: 50%;
      overflow: hidden;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .user_info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 11px;
      .top_box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .name_box {
          display: flex;
          align-items: flex-end;
          .name {
            font-size: 16px;
            font-weight: 800;
            margin-right: 10px;
          }
          .label {
            font-size: 13px;
            margin-right: 10px;
          }
          .start {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #999;
            > img {
              width: 17px;
              height: 18px;
              margin-left: 3px;
              vertical-align: bottom;
            }
          }
        }
        .interest_btn {
          width: 51px;
          height: 23px;
          background: #326afb;
          border-radius: 12px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          line-height: 23px;
          font-weight: bold;
        }
        .interested {
          background: #f7f8fb;
          color: #333;
        }
      }
      .msgInfo {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #a5a8b0;
        margin-top: 5px;
        .sixin_btn {
          margin-top: 10px;
          width: 51rpx;
          height: 23px;
          background: #fff;
          border-radius: 12px;
          font-size: 12px;
          color: #333;
          text-align: center;
          line-height: 23px;
          border: 2rpx solid #b6b6b6;
          font-weight: bold;
        }
      }
      .addre_box {
        display: flex;
        justify-content: space-between;
        .box {
          display: flex;
          align-items: center;
          > img {
            width: 13px;
            height: 13px;
            vertical-align: middle;
            margin-right: 5px;
            margin-top: 10px;
          }
          > div {
            font-size: 13px;
            color: #333;
            margin-top: 10px;
          }
        }
        .sixin_btn {
          margin-top: 10px;
          // width: 101rpx;
          height: 23px;
          background: #fff;
          border-radius: 12px;
          font-size: 12px;
          color: #333;
          text-align: center;
          line-height: 23px;
          font-weight: bold;
        }
      }
    }
  }
  .banner {
    width: 100%;
    height: 400px;
    overflow-y: auto;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 10px 10px 0 0;
    padding: 0 15px 15px;
    box-sizing: border-box;
    box-shadow: 0px 5px 5px 5px rgba(255, 255, 255, 1);
    .tabs_box {
      position: sticky;
      top: 0;
      z-index: 9;
      width: 100%;
      padding: 15px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #fff;

      .min_spec {
        cursor: pointer;
        font-size: 12px;
        color: #666;
        > img {
          width: 17px;
          height: 17px;
          vertical-align: middle;
          margin-top: -2px;
          margin-right: 3px;
        }
      }
    }
  }
}
.xuanz {
  position: relative;
  color: #326afb !important;
  font-weight: bold;
}

.xuanz::before {
  position: absolute;
  bottom: -9px;
  left: 50%;
  transform: translateX(-50%);
  content: '';
  width: 19px;
  height: 2px;
  background: #336bfb;
  border-radius: 1px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  .tit_box {
    font-size: 16px;
    font-weight: bold;
    color: #000000;

    display: flex;
    align-items: center;
    justify-content: space-between;
    .tip {
      font-size: 12px;
      font-weight: normal;
      color: #333;
      > text {
        color: #326afb;
      }
    }
  }
  .title {
    position: relative;
    font-size: 16px;
    width: 100%;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
    .el-button {
      position: absolute;
      top: -10px;
      right: 0;
    }
  }
  .more {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }
}
.bigBox {
  padding: 15px;
  box-sizing: border-box;
  .info {
    margin-bottom: 30px;
    .title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    > span {
      font-size: 14px;
      color: #666;
      line-height: 25px;
    }
  }
}
</style>
